// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__12OcK","actions":"GroupTable_actions__zs_tB","deleteModalFooter":"GroupTable_deleteModalFooter__2qq7h"};